/**
* DevExpress Dashboard (_grid-column-filter-options.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { parseBool, PropertyCategory } from '../../../metadata/_base-metadata';
export let showFilterRow = { propertyName: 'showFilterRow', modelName: '@ShowFilterRow', displayName: 'DashboardWebStringId.Grid.ShowFilterRow', defaultVal: false, simpleFormAdapterItem: 'onOffButtonGroupEditor', from: parseBool, category: PropertyCategory.ViewModel };
export let updateTotals = { propertyName: 'updateTotals', modelName: '@UpdateTotals', displayName: 'DashboardWebStringId.Grid.UpdateTotals', defaultVal: false, simpleFormAdapterItem: 'onOffButtonGroupEditor', from: parseBool };
export let gridColumnFilterOptionsSerializationsInfo = [showFilterRow, updateTotals];
